module.exports = __webpack_public_path__ + "img/5.83764837.svg";